import React from 'react'

interface AssigneeIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const AssigneeIcon: React.FC<AssigneeIconProps> = ({
  color = '#000',
  gradient,
  width = 18,
  height = 24,
  alt = 'Assignee icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 18 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M7.772 11.984l-.009-.009a1.65 1.65 0 01-.513-1.23c0-.486.163-.882.513-1.232A1.659 1.659 0 019.006 9c.484 0 .875.162 1.222.516l.009.009c.35.35.513.745.513 1.23 0 .486-.163.882-.513 1.232a1.65 1.65 0 01-1.231.513c-.499 0-.889-.164-1.234-.516zM9.006 7.75c.82 0 1.533.297 2.115.891.582.582.879 1.295.879 2.115 0 .82-.297 1.533-.88 2.115a2.899 2.899 0 01-2.114.879 2.871 2.871 0 01-2.127-.891A2.899 2.899 0 016 10.744c0-.82.297-1.533.88-2.115a2.906 2.906 0 012.126-.879zm1.308 8.09a4.925 4.925 0 001.004-.435l.102-.06-.315-.54.315.54.021-.012c.15-.088.338-.197.51-.315l.022-.013c.173.013.333.048.47.099.164.06.299.143.4.229.12.115.234.254.335.42l.007.012.007.011c.104.163.18.33.228.49l.008.028.01.027c.079.222.14.438.18.664l.002.009c.05.27.08.494.09.687l.002.034.004.035c.013.12.018.253.024.442v.004l.01.247c-.005.37-.123.586-.306.752-.187.17-.479.305-.981.305H5.537c-.484 0-.792-.138-.995-.317-.176-.156-.292-.363-.292-.766 0-.225.011-.455.024-.704a5.28 5.28 0 01.095-.665l.007-.031.006-.032c.046-.263.1-.476.166-.664l.01-.027.008-.028c.04-.132.12-.303.248-.521.096-.156.204-.29.317-.4.128-.101.272-.186.421-.245.135-.048.292-.082.462-.095l.037.022c.195.127.399.25.616.378.313.187.68.324.99.43l.03.01.03.01c.403.114.835.19 1.276.19.457 0 .877-.077 1.277-.19l.022-.007.022-.008zm.476-1.574l-.11.064c-.192.116-.439.22-.754.322-.316.09-.617.142-.933.142a3.42 3.42 0 01-.932-.142 4.059 4.059 0 01-.755-.322c-.22-.129-.411-.245-.59-.36-.274-.168-.41-.22-.562-.22-.37 0-.727.065-1.042.18a2.916 2.916 0 00-.81.478 3.322 3.322 0 00-.561.696c-.151.257-.288.528-.37.799-.097.27-.165.554-.22.864-.067.287-.094.562-.121.825l-.003.025a15.06 15.06 0 00-.027.8c0 .709.233 1.276.713 1.701.466.413 1.084.632 1.824.632h6.926c.74 0 1.358-.206 1.824-.632.466-.425.713-.992.713-1.701-.005-.09-.008-.179-.01-.267a7.498 7.498 0 00-.031-.533 6.55 6.55 0 00-.11-.85 5.357 5.357 0 00-.233-.864 3.242 3.242 0 00-.37-.8 3.324 3.324 0 00-.563-.695 2.566 2.566 0 00-.809-.477 3.038 3.038 0 00-1.042-.181c-.15 0-.288.052-.562.22-.137.096-.302.192-.48.296zM2.75 3.25C2.75 2.56 3.31 2 4 2h2a3.251 3.251 0 016 0h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25v-2zm8.25 0a2 2 0 10-4 0H4v2h10v-2h-3z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M4 2.5H2a2 2 0 00-2 2V22a2 2 0 002 2h14a2 2 0 002-2V4.5a2 2 0 00-2-2h-2v1.25h2a.75.75 0 01.75.75V22a.75.75 0 01-.75.75H2a.75.75 0 01-.75-.75V4.5A.75.75 0 012 3.75h2V2.5z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default AssigneeIcon
